<template>
    <transition name="modal" enter-active-class="animated fadeIn" appear>
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container">
                    <div class="modal-body m-0">
                        <slot name="body">
                            <div class="input-style input-style-2 has-icon input-required">
                                <i class="input-icon fa fa-check color-magenta2-light"></i>
                                <input id="subjectFolder" class="form-control" type="text" v-model="checkListFolderModel.subject" autofocus placeholder="عنوان">
                            </div>
                            <div class="mb-3 d-flex align-items-center" v-if="isExpired==false">
                                <b class="ml-2">ارسال یادآور</b>
                                <input  type="checkbox" v-model="checkListFolderModel.sendReminder">
                                <date-picker type="dateTime" v-model="checkListFolderModel.reminderDateTime" :auto-submit="true" format="jYYYY/jMM/jDD HH:mm" element="remDT" :jumpMinute="5" />
                            </div>
                            <div class="mb-3 d-flex align-items-center" >
                                <b v-show="isShowText" class="ml-2 text-justify">حساب کاربری شما منقضی شده است و امکان ثبت یادآور وجود ندارد</b>
                   
                            </div>
                            
                            <div class="mb-3 d-flex align-items-center">
                                <b v-show="showMsg" class="ml-2 text-justify">{{msg}}</b>

                            </div>

                            <div class="input-style input-style-2 has-icon input-required mb-0">
                                <i v-show="checkListFolderModel.sendReminder===true" class="input-icon fa fa-calendar-check color-magenta2-light"></i>
                                <span v-show="checkListFolderModel.sendReminder===true" class="color-highlight input-style-1-active">زمان یادآوری</span>
                                <input v-show="checkListFolderModel.sendReminder===true" class="form-control ltr text-left" type="text" id="remDT" v-model="checkListFolderModel.reminderDateTime" />
                            </div>
                        </slot>
                    </div>
                    <div class="modal-footer py-1 px-2">
                        <slot name="footer">
                            <button :disabled="Loading" class="btn btn-xxs rounded-s bg-green2-light" @click="SaveFolder">
                                <i class="fa fa-check ml-2"></i>
                                ثبت
                            </button>
                            <button class="btn btn-xxs rounded-s bg-red1-light" @click="$emit('close')">
                                <i class="fa fa-times ml-2"></i>
                                بستن
                            </button>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>



</template>
<script>
    import DatePicker from 'vue3-persian-datetime-picker';
    import VueSimpleAlert from "vue3-simple-alert";
    export default {
        components: {
            DatePicker,
        },
        props: ['checkListFolder','CheckListUserId'],
        data() {
            return {
                CheckListUser: this.CheckListUserId,
                checkListFolderModel: {
                    seq: 0,
                    subject: null,
                    sendReminder: false,
                    reminderDateTime: null,
                    passed: false,
                    disabled: false,
                    edited: false,
                    editing: false,
                    checkListId: 0,
                    checkListFolderId: 0,
                    checkListSubject: null,
                    checkListDate: null
                },
                Loading: false,
                isExpired: false,
                isShowText: false,
                errorMsg: null,
                readOnly: false,
                msg:"",
                showMsg:false,
            };
        },
        created() {
            this.$http.get("Task/TaskOnline_GetUserActiveStatus")
                .then(data => {
                    this.isExpired =data.data.expired;
                    this.isShowText = data.data.expired;
                    this.$http.get("Task/CheckUserSMS?userId=" + this.CheckListUser)
                        .then(data2 => {
                            if (!data2.data.isSuccess) {
                                this.sendReminder = false;
                                this.reminderDateTime = null;
                                this.showMsg = true;
                                this.isExpired = true;
                                this.msg = data2.data.message;
                            }
                        });
                });

        },
        mounted() {
            this.checkListFolderModel = this.checkListFolder;
            document.getElementById("subjectFolder").focus();

        },
        methods: {
           
            SaveFolder() {
                this.Loading = true;
                this.$emit('saveFolder', this.checkListFolderModel);
            }
        }

    };
</script>
<style>
       .modal-mask {
           position: fixed;
           z-index: 1;
           top: 0;
           left: 0;
           width: 100%;
           height: 100%;
           background-color: rgba(0, 0, 0, 0.5);
           display: table;
           transition: opacity 0.3s ease;
       }

       .modal-wrapper {
           display: table-cell;
           vertical-align: middle;
       }

       .modal-container {
           width: 300px;
           margin: 0px auto;
           background-color: #fff;
           border-radius: 2px;
           box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
           transition: all 0.3s ease;
       }

       .modal-header h3 {
           margin-top: 0;
           color: #42b983;
       }

       .modal-body {
           margin: 20px 0;
           line-height: 1;
       }

       .modal-default-button {
           float: right;
       }


       .modal-enter {
           opacity: 0;
       }

       .modal-leave-active {
           opacity: 0;
       }

           .modal-enter .modal-container,
           .modal-leave-active .modal-container {
               -webkit-transform: scale(2);
               transform: scale(2);
           }
</style>
